// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".carousel[data-v-29d4635e]{display:flex;justify-content:center;overflow:hidden;padding-bottom:5.6rem}.carousel .carousel-card-container[data-v-29d4635e]{height:15.8rem;position:relative;width:calc(100% - 5.6rem)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
